<template>
    <app-dialog
        :value="value"
        size="sm"
        append-to-body
        @input="$emit('input', $event)"
    >
        <template #header>
            <h3 class="text-lg font-semibold text-theme-base">
                ¿Cambiar a modo {{ optionLabel }}?
            </h3>
        </template>

        <div v-if="option" class="flex flex-col items-center">
            <div
                class="w-full rounded-lg border border-theme-border bg-theme-canvas py-4"
            >
                <display-mode-silhouette
                    class="mx-auto h-48 w-36 text-theme-primary"
                    :shapes="option.preview"
                    :labels="option.previewLabels"
                    :view-box="previewViewBox"
                />
            </div>

            <p class="mt-3 text-center text-sm text-theme-muted">
                {{ option.description }}
            </p>

            <p
                v-if="discardWarning"
                class="mt-3 w-full rounded-lg bg-theme-warning px-3 py-2 text-sm text-theme-inverse"
            >
                {{ discardWarning }}
            </p>
        </div>

        <template #footer>
            <div class="flex items-center gap-2">
                <app-button
                    class="flex-1"
                    color="success"
                    :loading="isSaving"
                    @click="$emit('confirm')"
                >
                    Cambiar
                </app-button>
                <button
                    type="button"
                    :disabled="isSaving"
                    class="rounded-lg border border-theme-border bg-theme-card px-3 py-2 text-sm font-medium text-theme-muted transition hover:bg-theme-hover disabled:opacity-50"
                    @click="$emit('input', false)"
                >
                    Cancelar
                </button>
            </div>
        </template>
    </app-dialog>
</template>

<script>
import {
    DISPLAY_MODE_PREVIEW_VIEW_BOX,
    LINKS_ONLY_DISPLAY_MODES
} from "@/common/fields/display-modes";

import DisplayModeSilhouette from "@/components/editor/DisplayModeSilhouette.vue";
import AppButton from "@/components/utils/AppButton.vue";
import AppDialog from "@/components/utils/AppDialog.vue";

export default {
    name: "DisplayModeConfirmModal",
    components: {
        AppButton,
        AppDialog,
        DisplayModeSilhouette
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        option: {
            type: Object,
            default: null
        },
        segmentsCount: {
            type: Number,
            default: 0
        },
        isSaving: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        optionLabel() {
            return this.option?.label ?? "";
        },
        previewViewBox() {
            return DISPLAY_MODE_PREVIEW_VIEW_BOX;
        },
        // 'feed' y 'catalog' no usan el editor de bloques: al cambiar, el
        // catálogo se rearma como un único bloque con todos los enlaces del
        // tenant y el resto de los bloques se descarta.
        discardWarning() {
            if (
                !LINKS_ONLY_DISPLAY_MODES.includes(this.option?.value) ||
                !this.segmentsCount
            ) {
                return "";
            }
            const blocks =
                this.segmentsCount === 1
                    ? "el bloque que tienes armado"
                    : `los ${this.segmentsCount} bloques que tienes armados`;
            return `Se reemplaza ${blocks} por uno solo con todos tus enlaces. Tus enlaces no se pierden, y guardamos una copia de tus bloques actuales — puedes recuperarlos desde el historial de versiones.`;
        }
    }
};
</script>
